Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

// Global Map to track tool call IDs to their corresponding spans
// This allows us to capture tool errors and link them to the correct span
const toolCallSpanMap = new Map();

exports.toolCallSpanMap = toolCallSpanMap;
//# sourceMappingURL=constants.js.map
